/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React from 'react';

function Footer() {
    return (
        <footer className="bg-light text-center py-3 mt-5 border-top">
            <div className="container">
                <span className="text-muted">&copy; {new Date().getFullYear()} Sovos. All rights reserved.</span>
            </div>
        </footer>
    );
}

export default Footer;
